import AcUnitIcon from '@mui/icons-material/AcUnit';
import { Restaurant } from '@mui/icons-material';
import BalconyIcon from '@mui/icons-material/Balcony';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import DeskIcon from '@mui/icons-material/Desk';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import KitchenIcon from '@mui/icons-material/Kitchen';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import LockIcon from '@mui/icons-material/Lock';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import PedalBikeIcon from '@mui/icons-material/PedalBike';
import PetsIcon from '@mui/icons-material/Pets';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import ShowerIcon from '@mui/icons-material/Shower';
import TvIcon from '@mui/icons-material/Tv';
import WifiIcon from '@mui/icons-material/Wifi';
import {
    Box,
    Card,
    FormHelperText,
    Grid,
    InputLabel,
    Stack,
    Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { capitalizeName } from '../../../../../shared/utils';
import { Controller, useFormContext } from 'react-hook-form';
import { useFormState } from '../../Form/useFormState';
import FormCounter from '../../../../shared/FormCounter';

export default function NewCommercialAmenitiesForm() {
    const { control, setValue } = useFormContext();
    const { experience } = useFormState();

    const theme = useTheme();

    const items = [
        {
            name: 'catering',
            selected: false,
            icon: <Restaurant fontSize='large' />,
        },
        {
            name: 'wifi',
            selected: false,
            icon: <WifiIcon fontSize='large' />,
        },
        {
            name: 'boardroom',
            selected: false,
            icon: <BusinessCenterIcon fontSize='large' />,
        },
        {
            name: 'tv',
            selected: false,
            icon: <TvIcon fontSize='large' />,
        },
        {
            name: 'kitchen',
            selected: false,
            icon: <KitchenIcon fontSize='large' />,
        },
        {
            name: 'parking',
            selected: false,
            icon: <LocalParkingIcon fontSize='large' />,
        },
        {
            name: 'aircon',
            selected: false,
            icon: <AcUnitIcon fontSize='large' />,
        },
        {
            name: 'dedicatedWorkspace',
            selected: false,
            icon: <DeskIcon fontSize='large' />,
        },

        {
            name: 'balcony',
            selected: false,
            icon: <BalconyIcon fontSize='large' />,
        },

        {
            name: 'bbq',
            selected: false,
            icon: <OutdoorGrillIcon fontSize='large' />,
        },

        {
            name: 'gym',
            selected: false,
            icon: <FitnessCenterIcon fontSize='large' />,
        },

        {
            name: 'diningOptions',
            selected: false,
            icon: <RestaurantIcon fontSize='large' />,
        },
        {
            name: 'petFriendly',
            selected: false,
            icon: <PetsIcon fontSize='large' />,
        },

        {
            name: 'showerRoom',
            selected: false,
            icon: <ShowerIcon fontSize='large' />,
        },
        {
            name: 'bikeLock',
            selected: false,
            icon: <PedalBikeIcon fontSize='large' />,
        },
        {
            name: 'personalStorage',
            selected: false,
            icon: <LockIcon fontSize='large' />,
        },

        {
            name: 'childcare',
            selected: false,
            icon: <ChildCareIcon fontSize='large' />,
        },
    ];

    const subType = experience.details?.subType;

    return (
        <fieldset>
            <Stack spacing={2}>
                <div>
                    <Typography variant='h2' component='legend'>
                        Experience Amenities
                    </Typography>
                    <Typography color='text.secondary' gutterBottom>
                        Tell guests what your{' '}
                        {subType === 'office' ? 'office space' : 'home office'}{' '}
                        has to offer
                    </Typography>
                </div>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='desks__input'>
                        No. Dedicated Desks
                    </InputLabel>
                    <FormCounter
                        id='desks__input'
                        name='details.desks'
                        // max={20}
                        disabled={false}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='private-offices__input'>
                        {subType === 'house'
                            ? `No. Rooms`
                            : `No. Private Offices`}
                    </InputLabel>
                    <FormCounter
                        id='private-offices__input'
                        name='details.privateOffices'
                        disabled={false}
                    />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='meeting-rooms__input'>
                        No. Meeting Rooms
                    </InputLabel>

                    <FormCounter
                        id='meeting-rooms__input'
                        name='details.meetingRooms'
                        disabled={false}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <div>
                        <InputLabel htmlFor='max-guests__input'>
                            Max Guests
                        </InputLabel>
                        <FormHelperText>
                            Occupancy of entire venue
                        </FormHelperText>
                    </div>
                    <FormCounter
                        id='max-guests__input'
                        name='details.maxGuests'
                        disabled={false}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <div>
                        <InputLabel htmlFor='meeting-room-max-guests__input'>
                            Max Meeting Room Guests
                        </InputLabel>
                        <FormHelperText>
                            Occupancy of meeting rooms
                        </FormHelperText>
                    </div>
                    <FormCounter
                        id='meeting-room-max-guests__input'
                        name='details.meetingRoomMaxGuests'
                        disabled={false}
                    />
                </Box>
            </Stack>
            <Typography
                color='textPrimary'
                pb='20px'
                pt='30px'
                id='experience-amenities-select'
            >
                Select available amenities:
            </Typography>
            <Grid
                container
                columns={{ lg: 5, md: 4, xs: 2 }}
                spacing={2}
                aria-labelledby='experience-amenities-select'
            >
                {items.map((item, i) => (
                    <Grid item xs={1} key={i}>
                        <Controller
                            name={`details.${item.name}`}
                            control={control}
                            render={({ field: { value } }) => (
                                <Card
                                    sx={{
                                        height: '100px',
                                        bgcolor: value
                                            ? theme.palette.primary.main
                                            : theme.palette.neutral.main,
                                        color: value
                                            ? theme.palette.primary.contrastText
                                            : theme.palette.text.primary,
                                    }}
                                    onClick={() =>
                                        setValue(
                                            `details.${item.name}`,
                                            !value,
                                            { shouldDirty: true },
                                        )
                                    }
                                >
                                    <Box
                                        display='flex'
                                        flexDirection='column'
                                        alignItems='center'
                                        height='100%'
                                        gap={1}
                                        justifyContent='center'
                                        textAlign='center'
                                    >
                                        {item.icon}
                                        <Typography
                                            sx={{
                                                color: value
                                                    ? theme.palette.primary
                                                          .contrastText
                                                    : theme.palette.text
                                                          .primary,
                                            }}
                                        >
                                            {item.name === 'diningOptions'
                                                ? 'Dining Options'
                                                : item.name === 'petFriendly'
                                                  ? 'Pet Friendly'
                                                  : item.name ===
                                                      'dedicatedWorkspace'
                                                    ? 'Dedicated Workspace'
                                                    : item.name === 'balcony'
                                                      ? 'Balcony/Outdoor Space '
                                                      : item.name === 'bbq'
                                                        ? 'BBQ'
                                                        : item.name ===
                                                            'showerRoom'
                                                          ? 'Shower/Change Room'
                                                          : item.name ===
                                                              'bikeLock'
                                                            ? 'Bike Lock'
                                                            : item.name ===
                                                                'personalStorage'
                                                              ? 'Personal Lockers/Storage'
                                                              : item.name ===
                                                                  'childcare'
                                                                ? 'Child Care'
                                                                : capitalizeName(
                                                                      item.name,
                                                                  )}
                                        </Typography>
                                    </Box>
                                </Card>
                            )}
                        />
                    </Grid>
                ))}
            </Grid>
        </fieldset>
    );
}
